'use strict';exports.__esModule = true;exports.saveSearchedLocation = exports.startSubmitting = exports.openAdvancedFilters = exports.hideMobileFilters = exports.openMobileFilters = undefined;var _reduxAct = require('redux-act');

var openMobileFilters = (0, _reduxAct.createAction)('/OPEN_MOBILE_FILTERS');
var hideMobileFilters = (0, _reduxAct.createAction)('/HIDE_MOBILE_FILTERS');
var openAdvancedFilters = (0, _reduxAct.createAction)('/OPEN_ADVANCED_FILTERS');
var startSubmitting = (0, _reduxAct.createAction)('/START_SUBMITTING');
var saveSearchedLocation = (0, _reduxAct.createAction)('/SAVE_SEARCHED_LOCATION');

var initialState = {
  isMobileFiltersOpen: false,
  optionType: null,
  isProjects: false,
  submitting: false,
  alreadySearchedLocation: null,
  isAdvancedFiltersOpen: false };


var handleOpen = function handleOpen(state, _ref) {var optionType = _ref.optionType,isProjects = _ref.isProjects;return Object.assign({},
  state, {
    isMobileFiltersOpen: true,
    submitting: false,
    alreadySearchedLocation: null,
    optionType: optionType,
    isProjects: isProjects });};


var handleHide = function handleHide(state) {return Object.assign({},
  state, {
    isMobileFiltersOpen: false,
    submitting: false,
    optionType: null,
    isAdvancedFiltersOpen: false });};


var handleAdvancedOpen = function handleAdvancedOpen(state) {return Object.assign({},
  state, {
    isAdvancedFiltersOpen: true });};


var handleSubmit = function handleSubmit(state) {return Object.assign({},
  state, {
    submitting: true });};


var handleSaveLocation = function handleSaveLocation(state, alreadySearchedLocation) {return Object.assign({},
  state, {
    alreadySearchedLocation: alreadySearchedLocation });};


var mobilesFilters = (0, _reduxAct.createReducer)(function (on) {
  on(openMobileFilters, handleOpen);
  on(hideMobileFilters, handleHide);
  on(openAdvancedFilters, handleAdvancedOpen);
  on(startSubmitting, handleSubmit);
  on(saveSearchedLocation, handleSaveLocation);
}, initialState);exports.


openMobileFilters = openMobileFilters;exports.
hideMobileFilters = hideMobileFilters;exports.
openAdvancedFilters = openAdvancedFilters;exports.
startSubmitting = startSubmitting;exports.
saveSearchedLocation = saveSearchedLocation;exports.default =


mobilesFilters;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/mobilesFilters.js
// module id = 233
// module chunks = 0